/**
 * HelpOption component
 * rendering the Help Center, Community, Email Us, and resolution center option in the Call us redesign container
 */
import React from 'react';
import PropTypes from 'prop-types';

const HelpOption = function (props) {
  const { className = '', header, message, onClick, display } = props;

  if (!display) {
    return null;
  }

  const attrs = {
    className: `help-option-container ${className}`,
  };

  return (
    <div {...attrs}>
      <div className="help-option-icon" aria-hidden="true" />
      <div className="help-option-content">
        <button className="help-option-label" onClick={onClick}>
          {header}
        </button>
        <div className="help-option-message">{message}</div>
      </div>
    </div>
  );
};

HelpOption.propTypes = {
  className: PropTypes.string,
  header: PropTypes.string,
  message: PropTypes.string,
  onClick: PropTypes.func,
  display: PropTypes.bool,
};

HelpOption.defaultProps = {
  display: true,
  className: '',
  header: '',
  message: '',
  onClick: () => {},
};

export default HelpOption;
